import React from 'react'

const Footer = () => {
  return (
    <div style={{background: '#e4e4e4', fontSize: '0.8rem', padding: '2px'}}>Spice Route Catters - Catering & Events</div>
  )
}

export default Footer